import React from 'react';
import LoadingSequence from 'assets/Loading/LoadingSequence';
import WidgetDiagnostics from './WidgetDiagnostics';
import { useWidgetFetch } from 'hooks/useWidgetFetch';
import { apiPath } from 'apiurl';

const TOOL_PALETTE = ['#3665e3', '#7c3aed', '#e25822', '#16a34a'];

function RunTypeDistribution({ timeRange }) {
  const url = `${apiPath}/api/dashboard-status/summary?timeRange=${timeRange}`;
  const { data, loading, timing } = useWidgetFetch(url, { ttl: 5 * 60 * 1000, swr: 10 * 60 * 1000, widgetId: 'Run Types' });

  const distribution = (data?.runTypeDistribution ?? []).map((entry, idx) => ({
    ...entry,
    color: TOOL_PALETTE[idx % TOOL_PALETTE.length],
  }));

  const hasData = distribution.some(e => e.value > 0);
  const total   = distribution.reduce((s, e) => s + e.value, 0) || 1;

  return (
    <div className="dash-insight-card">
      <div className="insight-header">
        <span className="insight-dot insight-green" />
        <span className="insight-title">Run Type Distribution</span>
        <WidgetDiagnostics timing={timing} url={url} />
      </div>
      {loading ? (
        <LoadingSequence message="Loading" size="small" />
      ) : !hasData ? (
        <div className="insight-empty">No run type data found.</div>
      ) : (
        <div className="rtype-root">
          <div className="rtype-header">
            <span className="rtype-total">{Number(total).toLocaleString()}</span>
            <div className="rtype-meta">
              <span className="rtype-label">pipeline executions</span>
            </div>
          </div>
          <div className="rtype-list">
            {distribution.map(entry => {
              const pct = (entry.value / total) * 100;
              return (
                <div key={entry.name} className="rtype-item" style={{ '--c': entry.color }}>
                  <span className="rtype-swatch" />
                  <span className="rtype-name">{entry.name}</span>
                  <span className="rtype-count">{entry.value.toLocaleString()}</span>
                  <span className="rtype-pct">{pct < 1 ? '<1' : Math.round(pct)}%</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default RunTypeDistribution;
